import { render, staticRenderFns } from "./SchoolClassInput.vue?vue&type=template&id=dd7d7134"
import script from "./SchoolClassInput.vue?vue&type=script&lang=js"
export * from "./SchoolClassInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports